<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card border">
          <div class="card-body">
            <h5 class="card-title h4 text-center">{{ $t(titulo) }}</h5>
            <div class="row mt-2">
              <div class="col-12">
                <div class="form-group">
                  <label for="exampleInputEmail1"
                    >{{ $tc("telefono", 1) }}
                    <span v-if="myNewPhone.country_id"
                      >(+{{ paisCodTel(myNewPhone.country_id) }})</span
                    ></label
                  >
                  <input
                    type="text"
                    maxlength="9"
                    class="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    v-model="myNewPhone.phone"
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label for="exampleInputEmail1">{{ $t("pais") }}</label>
                  <select
                    class="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="Enter email"
                    v-model="myNewPhone.country_id"
                  >
                    <!--  <option disabled value selected>{{}}</option> -->
                    <option
                      v-for="pais in countries"
                      v-bind:key="pais.id"
                      v-bind:value="pais.id"
                      >{{
                        pais.name
                          | filterTranslateCountry(
                            pais.id,
                            pais.translations,
                            $i18n.locale
                          )
                      }}</option
                    >
                  </select>

           <!--        <small id="emailHelp" class="form-text text-muted"
                    >We'll never share your email with anyone else.</small
                  > -->
                </div>
              </div>
            </div>
            <div class="row">
              <p class="mt-2 col-lg-12 mb-2">
                <button
                  class="btn btn-sm btn-outline-primary mt-2 float-right ml-2 pt-2 pb-2 btn-w"
                  @click.prevent="guardarNewPhone"
                >
                  {{ $t("guardar") }}
                  <i class="fa fa-plus-circle"></i>
                </button>
                <button
                  class="btn btn-sm btn-outline-warning mt-2 float-right pt-2 pb-2 btn-w"
                  @click.prevent="cancelarNewPhone(false)"
                >
                  {{ $t("cancelar") }}
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import CountryFlag from "vue-country-flag";
import { cloneDeep } from "lodash";

export default {
  name: "user-phone-new",
  props: ["countries", "newPhone", "editPhone"],
  components: { CountryFlag },
  data() {
    return {
      myNewPhone: {
        country_id: null,
        phone: null
      },
      titulo: "nuevo telefono",
      editando: false,      
    };
  },
  computed: {
    ...mapState("phone", ["loading", "currentEditPhone"])
  },
  methods: {
    ...mapActions("phone", ["createUserPhone", "updateUserPhone"]),
    paisCode(id) {
      if (id === null) return "";
      const country = this.countries.find(c => c.id === id);     
      if (!!country.iso) {
        return country.iso.toLowerCase();
      } else {
        return "";
      }
    },
    paisCodTel(id) {
      if (id === null) return "";
      const country = this.countries.find(c => c.id === id);
      //console.log(country, !country.iso);
      if (!!country.phonecode) {
        return country.phonecode;
      } else {
        return "";
      }
    },

    guardarNewPhone() {
      if (!this.editando) {
        this.createUserPhone(this.myNewPhone);
        this.cancelarNewPhone(true);
      } else {
        //editamos un telf
       // const datos = Object.assign(datos, this.editPhone);
        let tmp = {
          id: this.editPhone.id,
          ...this.myNewPhone
        }
        console.log(tmp)
        
        this.updateUserPhone(tmp).then(res => {
          this.cancelarNewPhone(true);
        });

      }
      
    },

    cancelarNewPhone(refresh = false) {
      this.$emit("newPhoneShowEmit", refresh);
    }
  },
  mounted() {
    //console.log(this.countries);
    if (this.editPhone !== null) {
      this.editando = true;
      this.titulo = "editanto telefono";
      this.myNewPhone.phone = this.editPhone.phone;
      this.myNewPhone.country_id = this.editPhone.country_id;
      //estamos editando un telefono
      console.log("editando un telefono", this.titulo, this.myNewPhone)
    }
  }
};
</script>

<style scoped>
input,
select {
  max-height: 35px;
  margin-left: 0px;
  background-color: #fff;
  border: 1px solid #ccc;
}
select {
  padding: 1px;
}
</style>
